document.addEventListener('DOMContentLoaded', function () {

    var enquiryModal = document.getElementById('ewEnquiryModal');

    if (!enquiryModal) {
        return;
    }


    enquiryModal.addEventListener('show.bs.modal', function (event) {
        var button = event.relatedTarget;
        var cardName = button.getAttribute('data-card-name');
        var cardId = button.getAttribute('data-card-id');

        // Update the modal's title
        var modalCardName = enquiryModal.querySelector('#ewEnquiryModalCardName');
        modalCardName.textContent = cardName;

        // Update the CF7 hidden input
        var hiddenVenueInput = enquiryModal.querySelector('.wpcf7-form-control[name="venue_name"]');
        if (hiddenVenueInput) {
            hiddenVenueInput.value = cardName;
        }

        var hiddenVenueInputId = enquiryModal.querySelector('.wpcf7-form-control[name="venue_id"]');
        if (hiddenVenueInputId) {
            hiddenVenueInputId.value = cardId;
        }
    });

    enquiryModal.addEventListener('hidden.bs.modal', function () {
        var modalCf7Forms = enquiryModal.querySelectorAll('.wpcf7 form');

        modalCf7Forms.forEach(function (form) {
            form.reset();
            form.classList.remove('sent', 'invalid', 'failed', 'submitting', 'unaccepted', 'payment-required', 'spam');

            form.querySelectorAll('.wpcf7-not-valid').forEach(function (field) {
                field.classList.remove('wpcf7-not-valid');
            });

            form.querySelectorAll('.wpcf7-not-valid-tip').forEach(function (tip) {
                tip.remove();
            });

            form.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
                field.setAttribute('aria-invalid', 'false');
            });

            form.querySelectorAll('.wpcf7-spinner').forEach(function (spinner) {
                spinner.classList.remove('is-active');
            });

            var responseOutput = form.parentElement.querySelector('.wpcf7-response-output');
            if (responseOutput) {
                responseOutput.innerHTML = '';
                responseOutput.setAttribute('aria-hidden', 'true');
            }
        });
    });



    //Formhance
    const suggestions = {
        descriptions: {
            "0": "Hi there, do you have any wedding packages you could send to us? Thanks!",
            "1": "Hello, I was wondering about your availability...",
            "2": "Hello, are you able to let me know your prices? Thank You!",
            "3": "Hi, we were wondering if we could get a quote for your services at our wedding please? Many thanks.",
            "0,1": "Hello! Would you be available for our wedding? We'd love to find out more about your packages. Thank you!",
            "0,2": "Hi! We'd like to find out more about what packages you offer. Could you please send us through some details about your packages and pricing? Thanks!",
            "0,3": "Hello! We'd like to find out more information. Would you be able to send through some info about what wedding packages you have and what you need for a quote? Thank you.",
            "1,2": "Hi, would you be available for our wedding? We'd like to know more about prices please. Thank you!",
            "1,3": "Hi! Are you available for our wedding date? We'd love to get a quote. Thanks!",
            "2,3": "Hi! Would you be able to send us a quote or some details about pricing please? Thank you!",
            "0,2,3": "Hi! We'd like to chat to you about our wedding. Could you please send me some details about your packages and pricing or quotes? Thank you!",
            "1,2,3": "Hi! I was wondering if you're available for our wedding? I'd be interested in finding out more about your quotes and pricing. Thank you.",
            "0,1,3": "Hi, we're interested to see whether you'd be available for our wedding. Would you be able to send through some details about your packages and quotes? Thanks!",
            "0,1,2": "Hi, would you be available for our wedding? We'd love to know more about your packages and prices. Thanks.",
            "0,1,2,3": "Hi! We've been looking at your services for our wedding. We'd love to find out more about your prices or quotes, as well as your availability and packages. Thank you so much!"
        }
    };

    document.querySelectorAll('.form-container').forEach((container, formIndex) => {
        // For each .form-tags group (there's one in vertical and one in horizontal)
        container.querySelectorAll('.form-tags').forEach((tagGroup, groupIndex) => {
            const groupCheckboxes = Array.from(tagGroup.querySelectorAll('.form-check-input'));

            // Ensure unique IDs for a11y, per group
            groupCheckboxes.forEach((cb, i) => {
                const newId = `cb-${formIndex}-${groupIndex}-${i}`;
                cb.id = newId;
                const label = cb.closest('.form-check')?.querySelector('label');
                if (label) label.setAttribute('for', newId);
            });
        });

        // Delegate changes within this container
        container.addEventListener('change', (e) => {
            if (!e.target.classList.contains('form-check-input')) return;

            // Find the specific group these checkboxes belong to
            const tagGroup = e.target.closest('.form-tags');
            if (!tagGroup) return;

            // Find the textarea that belongs to THIS group:
            // In your markup, textarea is the previous sibling of .form-tags
            let textarea = tagGroup.previousElementSibling;
            if (!textarea || textarea.tagName !== 'TEXTAREA') {
                // Fallback if structure changes
                textarea = tagGroup.parentElement.querySelector('textarea');
            }
            if (!textarea) return;

            // Compute indices only within this group's checkboxes
            const groupCheckboxes = Array.from(tagGroup.querySelectorAll('.form-check-input'));
            const selectedIndexes = groupCheckboxes
                .map((cb, i) => (cb.checked ? i : null))
                .filter(i => i !== null)
                .sort((a, b) => a - b);

            const key = selectedIndexes.join(',');
            textarea.value = suggestions.descriptions[key] || '';
        });
    });
    const entryContent = document.querySelector(".entry-content");
    if (entryContent) {
        const h1s = entryContent.querySelectorAll("h1");
        h1s.forEach(h1 => {
            const h2 = document.createElement("h2");
            h2.innerHTML = h1.innerHTML;
            // copy attributes if needed
            for (let attr of h1.attributes) {
                h2.setAttribute(attr.name, attr.value);
            }
            h1.replaceWith(h2);
        });
    }
});

jQuery(document).ready(function ($) {

    // Fix for Bootstrap 5 modal focus enforcement blocking jQuery UI Datepicker interaction
    // We use a capturing listener to stop the focusin event from reaching Bootstrap's listener
    document.addEventListener('focusin', function (e) {
        if (e.target.closest('#ui-datepicker-div')) {
            e.stopImmediatePropagation();
        }
    }, true);

    if ($.fn.datepicker) {
        $('.datepicker').datepicker({
            dateFormat: 'mm/dd/yy', // Change format as needed
            changeMonth: true,
            changeYear: true,
            minDate: 0,
            beforeShow: function (input, inst) {
                var isModal = $(input).closest('.modal').length > 0;

                if (isModal) {
                    $('#ui-datepicker-div').addClass('in-modal');
                    var rect = input.getBoundingClientRect();
                    setTimeout(function () {
                        $('#ui-datepicker-div').css({
                            top: rect.bottom + 'px',
                            left: rect.left + 'px',
                            position: 'fixed'
                        });
                    }, 0);
                } else {
                    $('#ui-datepicker-div').removeClass('in-modal');
                    // Reset position to default just in case
                    $('#ui-datepicker-div').css({
                        position: 'absolute',
                        top: '',
                        left: ''
                    });
                }
            },
            onClose: function (dateText, inst) {
                $('#ui-datepicker-div').removeClass('in-modal');
            }
        });
    }

    // Remove vertical-form if inside #storefront-contact
    var verticalForms = document.querySelectorAll('#storefront-contact .vertical-form');
    verticalForms.forEach(function (form) {
        form.remove();
    });

    // Remove vertical-form if inside enquiry modal
    var modalForms = document.querySelectorAll('#ewEnquiryModal .vertical-form');
    modalForms.forEach(function (form) {
        form.remove();
    });

    // Remove horizontal-form if inside #storefront-sidebar
    var horizontalForms = document.querySelectorAll('#storefront-sidebar .horizontal-form');
    horizontalForms.forEach(function (form) {
        form.remove();
    });
});